import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useT } from "@/i18n/I18nProvider";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const INITIAL_REFERRAL = {
  participant_name: "", participant_dob: "", participant_address: "", participant_email: "", participant_phone: "", participant_gender: "", atsi_descent: "", cultural_background: "",
  ndis_number: "", ndis_plan_dates: "", funding_type: [], plan_manager: "", plan_manager_email: "", plan_manager_phone: "", plan_copy_provided: "", other_provider: "", other_provider_name: "", service_type: "",
  disability_primary: "", disability_secondary: "", physical_mobility: "", cognitive_ability: "", other_info: "",
  carer_name: "", carer_address: "", carer_relationship: "", carer_phone: "", carer_email: "",
  referrer_name: "", referrer_relationship: "", referrer_organisation: "", referrer_address: "", referrer_phone: "", referrer_email: "",
};

const toPayload = (f) => Object.fromEntries(Object.entries(f).map(([k, v]) => [k, v === "" ? null : v]));

const errorMessage = (err, fallback) => {
  const detail = err.response?.data?.detail;
  return Array.isArray(detail) ? detail.map((d) => `${d.loc?.slice(-1)[0]}: ${d.msg}`).join("; ") : fallback;
};

export const useReferralForm = () => {
  const t = useT();
  const [form, setForm] = useState(INITIAL_REFERRAL);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(null);

  const onChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
  const toggleFunding = (opt) => setForm((f) => ({ ...f, funding_type: f.funding_type.includes(opt) ? f.funding_type.filter((x) => x !== opt) : [...f.funding_type, opt] }));
  const reset = () => { setDone(null); setForm(INITIAL_REFERRAL); };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/referrals`, toPayload(form));
      setDone(data);
      window.scrollTo({ top: 0, behavior: "smooth" });
      toast.success(t("Referral submitted successfully."));
    } catch (err) {
      toast.error(errorMessage(err, t("Submission failed. Please try again.")));
    } finally {
      setLoading(false);
    }
  };

  return { form, loading, done, onChange, toggleFunding, reset, submit };
};
